module.exports = __webpack_public_path__ + "img/login-solar-hero-night.0e6fecc1.jpg";